import { RemoteAddressSuggesterService } from '@prodcard/core-web-app'
import { httpClient } from './remote'

const addressSuggesterService = new RemoteAddressSuggesterService(httpClient)
export { addressSuggesterService }
